import { style } from '@do/walrus';
import { ReactElement } from 'react';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';
import { ButtonImage, ButtonImageBg, ButtonProps } from './Common';
import { ButtonStyle, StyledButton } from './SharedStyles';

const CustomButton = styled(StyledButton)`
  margin-top: ${style.vars.whitespace.regular};
  border: ${style.vars.borderWidth.thin} solid ${vars.grey6};
  border-radius: ${vars.border_radius_xlarge};
  color: ${vars.grey3};
`;

interface OauthButtonProps extends ButtonProps {
  iconSrc: string;
  buttonStyle?: ButtonStyle;
}

const OauthButton = ({
  text,
  onClick,
  disabled = false,
  iconSrc,
  dataTrackingId,
  buttonStyle,
}: OauthButtonProps): ReactElement => {
  return (
    <CustomButton
      fullWidth
      variation="secondary"
      onClick={onClick}
      disabled={disabled}
      data-tracking-id={dataTrackingId}
      buttonStyle={buttonStyle}
    >
      <ButtonImageBg>
        <ButtonImage src={iconSrc} />
      </ButtonImageBg>
      {text}
    </CustomButton>
  );
};

export default OauthButton;
